<template>
	<div class="h-100 vstack justify-content-center">
		<router-view v-slot="{ Component }">
			<transition name="route" mode="out-in">
				<component :is="Component" />
			</transition>
		</router-view>
	</div>
</template>